import {  IsNotEmpty, IsAlphanumeric, MaxLength, Matches, IsOptional, IsNumber } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';

export class WorkstationRequest {
    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    workstationId: number;

    @ApiProperty()
    @IsNotEmpty()
    @IsAlphanumeric()
    unitId: number;

    @ApiProperty()
    @IsOptional()
    updatedUser?: string;

    @ApiProperty()
    @IsOptional()
    @IsNumber()
    versionFlag?: number;

    @ApiProperty()
    isActive?: boolean;
    constructor(workstationId: number,unitId:number){
        this.workstationId = workstationId;
        this.unitId = unitId;
        
    }
}